import { PAYMENT_TYPE } from '../PaymentType';

export const PAYMENT_METHOD_TYPE_TO_PATH_MAP = {
    [PAYMENT_TYPE.CARD]: 'card-payment-method',
    [PAYMENT_TYPE.ACH_BANK_DIRECT_DEBIT]: 'ach-payment-method',
};
